import React, { useState } from 'react';
import { Search, X, Filter } from 'lucide-react';

const SearchBar = ({ onSearch, onFilterChange, commissions, types, years }) => {
  const [query, setQuery] = useState('');
  const [showFilters, setShowFilters] = useState(false);
  const [selectedType, setSelectedType] = useState('');
  const [selectedCommission, setSelectedCommission] = useState('');
  const [selectedYear, setSelectedYear] = useState('');

  const handleSearch = (value) => {
    setQuery(value);
    onSearch(value, { type: selectedType, commission: selectedCommission, year: selectedYear });
  };

  const handleTypeChange = (type) => {
    setSelectedType(type);
    onSearch(query, { type, commission: selectedCommission, year: selectedYear });
    if (onFilterChange) {
      onFilterChange({ type, commission: selectedCommission, year: selectedYear });
    }
  };

  const handleCommissionChange = (commission) => {
    setSelectedCommission(commission);
    onSearch(query, { type: selectedType, commission, year: selectedYear });
    if (onFilterChange) {
      onFilterChange({ type: selectedType, commission, year: selectedYear });
    }
  };

  const handleYearChange = (year) => {
    setSelectedYear(year);
    onSearch(query, { type: selectedType, commission: selectedCommission, year });
    if (onFilterChange) {
      onFilterChange({ type: selectedType, commission: selectedCommission, year });
    }
  };

  const clearFilters = () => {
    setQuery('');
    setSelectedType('');
    setSelectedCommission('');
    setSelectedYear('');
    onSearch('', { type: '', commission: '', year: '' });
    if (onFilterChange) {
      onFilterChange({ type: '', commission: '', year: '' });
    }
  };

  const hasActiveFilters = selectedType || selectedCommission || selectedYear || query;

  return (
    <div className="bg-white rounded-lg shadow-md p-4 mb-6">
      <div className="flex gap-3">
        <div className="flex-1 relative">
          <Search className="absolute left-3 top-1/2 transform -translate-y-1/2 text-gray-400" size={20} />
          <input
            type="text"
            placeholder="Rechercher par titre, auteur, tags..."
            value={query}
            onChange={(e) => handleSearch(e.target.value)}
            className="w-full pl-10 pr-4 py-3 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-primary-500 focus:border-transparent"
          />
        </div>
        <button
          onClick={() => setShowFilters(!showFilters)}
          className={`flex items-center gap-2 px-4 py-3 rounded-lg transition-colors ${
            showFilters
              ? 'bg-primary-600 text-white'
              : 'bg-gray-100 text-gray-700 hover:bg-gray-200'
          }`}
        >
          <Filter size={20} />
          <span>Filtres</span>
        </button>
        {hasActiveFilters && (
          <button
            onClick={clearFilters}
            className="flex items-center gap-2 px-4 py-3 bg-red-50 text-red-600 rounded-lg hover:bg-red-100 transition-colors"
          >
            <X size={20} />
            <span>Effacer</span>
          </button>
        )}
      </div>

      {showFilters && (
        <div className="mt-4 pt-4 border-t border-gray-200 grid grid-cols-3 gap-4">
          <div>
            <label className="block text-sm font-medium text-gray-700 mb-2">
              Statut
            </label>
            <select
              value={selectedType}
              onChange={(e) => handleTypeChange(e.target.value)}
              className="w-full px-3 py-2 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-primary-500"
            >
              <option value="">Tous les statuts</option>
              {types && types.map((type) => (
                <option key={type} value={type}>
                  {type === 'PUBLISHED' ? 'Publié' : type === 'DRAFT' ? 'Brouillon' : type === 'ARCHIVED' ? 'Archivé' : type}
                </option>
              ))}
            </select>
          </div>

          <div>
            <label className="block text-sm font-medium text-gray-700 mb-2">
              Commission
            </label>
            <select
              value={selectedCommission}
              onChange={(e) => handleCommissionChange(e.target.value)}
              className="w-full px-3 py-2 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-primary-500"
            >
              <option value="">Toutes les commissions</option>
              {commissions && commissions.map((commission) => (
                <option key={commission.id} value={commission.id}>
                  {commission.name}
                </option>
              ))}
            </select>
          </div>

          <div>
            <label className="block text-sm font-medium text-gray-700 mb-2">
              Année
            </label>
            <select
              value={selectedYear}
              onChange={(e) => handleYearChange(e.target.value)}
              className="w-full px-3 py-2 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-primary-500"
            >
              <option value="">Toutes les années</option>
              {years && years.map((year) => (
                <option key={year} value={year}>
                  {year}
                </option>
              ))}
            </select>
          </div>
        </div>
      )}
    </div>
  );
};

export default SearchBar;
